import React from "react";
import "./Contact.css";
import telegramicon from "../Assets/Telegram-cpn.png";
import phoneicon from "../Assets/Phone.png";
import emailicon from "../Assets/Mail-icon.png";
import phoneicon_hover from "../Assets/Phone_hover.png"
import telegramicon_hover from "../Assets/Telegram-cpn_hover.png"
import emailicon_hover from "../Assets/Mail-icon_hover.png"

function Contactme() {
    return (
<section id='contact-me' class="contact-me">
  <div class="contact-me-container">
    <h2 className="contact-me-title">Contact me</h2>
    <h2 className="contact-me-description">I’d love to hear from you! Whether you have a project in mind, need more information, or just want to chat, feel free to reach out. Let’s create something amazing together.</h2>
    <div class="contact-me-content">
        <a href="tel:+998999116526" target="_blank" rel="noopener noreferrer" class="contact-me-line" className="custom-link"
        onMouseEnter={(e) => {
            const img = e.currentTarget.querySelector('img');
            if (img) img.src = phoneicon_hover; // Replace the image
            const text = e.currentTarget.querySelector('.contact-me-text');
            if (text) text.style.color = '#ff0000'; // Change text color (example)
          }}
          onMouseLeave={(e) => {
            const img = e.currentTarget.querySelector('img');
            if (img) img.src = phoneicon; // Reset the image
            const text = e.currentTarget.querySelector('.contact-me-text');
            if (text) text.style.color = ''; // Reset text color
          }}
        >
            <img
            alt="contacticon"
            src={phoneicon}
            className="contact-me-icon"
            />
            <h2 className="contact-me-text">+998999116526</h2>
          </a>
        <a href="https://t.me/shohruh_karimqulov" target="_blank" rel="noopener noreferrer" class="contact-me-line" className="custom-link"
        onMouseEnter={(e) => {
            const img = e.currentTarget.querySelector('img');
            if (img) img.src = telegramicon_hover; // Replace the image
            const text = e.currentTarget.querySelector('.contact-me-text');
            if (text) text.style.color = '#ff0000'; // Change text color (example)
          }}
          onMouseLeave={(e) => {
            const img = e.currentTarget.querySelector('img');
            if (img) img.src = telegramicon; // Reset the image
            const text = e.currentTarget.querySelector('.contact-me-text');
            if (text) text.style.color = ''; // Reset text color
          }}
        >
            <img
            alt="contacticon"
            src={telegramicon}
            className="contact-me-icon"
            />
            <h2 className="contact-me-text">shohruh_karimqulov</h2>
          </a>
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=shohruh.karimqulov@shokhdesign.uz&su=Hello&body=I have a new project." target="_blank" rel="noopener noreferrer" class="contact-me-line" className="custom-link"
        onMouseEnter={(e) => {
            const img = e.currentTarget.querySelector('img');
            if (img) img.src = emailicon_hover; // Replace the image
            const text = e.currentTarget.querySelector('.contact-me-text');
            if (text) text.style.color = '#ff0000'; // Change text color (example)
          }}
          onMouseLeave={(e) => {
            const img = e.currentTarget.querySelector('img');
            if (img) img.src = emailicon; // Reset the image
            const text = e.currentTarget.querySelector('.contact-me-text');
            if (text) text.style.color = ''; // Reset text color
          }}
        >
            <img
            alt="contacticon"
            src={emailicon}
            className="contact-me-icon"
            />
            <h2 className="contact-me-text">shohruh.karimqulov@shokhdesign.uz</h2>
          </a>
      </div>
      </div>
</section>
    );
}

export default Contactme